import React from 'react';
import cookieDough from 'cookie-dough';
import Grid from '../Grid';
import { HeroStyled, TextHeader, Headline, HighLightText, Tag, ImageBlock, Button } from './styled';

const cookie = cookieDough();

const AB_TEST = 'cta-features-pgs';

class Hero extends React.Component {
  componentDidMount() {
    const abExperiments = this.getExperiments();
    if (abExperiments && abExperiments[AB_TEST]) {
      window.metricsLib.track(`ab:viewed-${AB_TEST}`, {
        experiment_id: AB_TEST,
        variation_id: abExperiments[AB_TEST],
      });
    }
  }

  getExperiments() {
    return this.props.abExperiments || JSON.parse(cookie.get('ajs_ab.traits'));
  }

  render() {
    const abExperiments = this.getExperiments();
    return (
      <HeroStyled>
        <Grid>
          <TextHeader>
            <Tag>
              <img
                src="https://cdn.auth0.com/website/machine-to-machine/img/hero/m2m-hero-icon.svg"
                alt="Machine to Machine"
              />
              <h2>MACHINE-TO-MACHINE COMMUNICATION</h2>
            </Tag>
            <Headline>
              Simplify Communication Between APIs and <br />Trusted Services
            </Headline>
            <HighLightText>
              Easily handle authentication and authorization for non-interactive applications ranging
              from IoT and trusted subsystem interactions to daemons
            </HighLightText>
            {abExperiments && abExperiments[AB_TEST] === 'variant' ?
              (
                <Button href="/get-started" target="_blank" className="btn btn-success btn-lg">
                  Get Started
                </Button>
              ) : (
                <div>
                  {console.log({abExperiments, test: abExperiments[AB_TEST] === 'variant'})}
                  <Button href="javascript:signup()" className="btn btn-success btn-lg">
                    Get Started
                  </Button>
                  <Button
                    href="https://auth0.com/docs/applications/machine-to-machine"
                    className="btn btn-transparent btn-lg white"
                  >
                    Read The Docs
                  </Button>
                </div>
              )
            }
          </TextHeader>
          <ImageBlock>
            <video
              muted={'true'}
              autoPlay={'true'}
              loop={'true'}
              src="https://videos.ctfassets.net/uv3ln4emu9ke/1vRvqD3qxWKYggiU0CY8iw/250ba01db0e398c05af1d039b75b8200/hero-animation__1_.mp4"
            />
            <img
              src="https://cdn.auth0.com/website/machine-to-machine/image/hero/hero-image.svg"
              alt="Simplify Communication Between APIs and Trusted Services"
            />
          </ImageBlock>
        </Grid>
      </HeroStyled>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Hero/Hero.js